export default __webpack_public_path__ + "static/media/Medium's Gloves of Supreme Decree.180ca68c.jpg";